// components/ContactSection.jsx

import React from "react";
import styles from "../styles/ContactSection.module.css";

export default function ContactSection() {
  return (
    <section className={styles.section} id="contact">
      <div className={styles.container}>
        
        <div className={styles.info}>
          <span>Contact</span>

          <h2>Visit Mesogeios</h2>

          <p>
            Located in beautiful Garista Corfu, Mesogeios offers authentic Mediterranean
            dining and unforgettable evenings.
          </p>

          <div className={styles.details}>
            <div>
              <h4>Address</h4>
                <p>
                  Mesogeios Restaurant<br />
                  Alkiviadou Dari 53
                </p>
            </div>
            <div>
              <h4>Phone</h4>
              <p>+30 2661 045827</p>
            </div>

            <div>
              <h4>Email</h4>
              <p>restaurantmesogeios@gmail.com</p>
            </div>
          </div>
        </div>

        <div className={styles.map}>
          <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3073.7461509685713!2d19.92280617674295!3d39.610400504319266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135b5e74b1fcd8e5%3A0x38516efd0fc0d0d9!2sMesogeios!5e0!3m2!1sen!2sgr!4v1778664538144!5m2!1sen!2sgr"  
          allowFullScreen="yes" 
          loading="lazy" 
          title="Mesogeios map"
          referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </section>
  );
}